export const updateShowButtons = (number) => (dispatch, getState) => {
  if (getState().skatepark.home.showButtons === number) {
    dispatch({
      type: 'SHOW_SKATEPARK_BUTTONS',
      payload: 0
    });
  } else {
    dispatch({
      type: 'SHOW_SKATEPARK_BUTTONS',
      payload: number
    });
  }
};
